export const generateEcdhKeyPair = async () => {
  const keyPair = await window.crypto.subtle.generateKey(
    {
      name: 'ECDH',
      namedCurve: 'P-256',
    },
    true,
    ['deriveKey', 'deriveBits']
  );

  const publicKeyBuffer = await window.crypto.subtle.exportKey('raw', keyPair.publicKey);
  const privateKeyBuffer = await window.crypto.subtle.exportKey('pkcs8', keyPair.privateKey);

  const publicKeyHex = bufferToHex(publicKeyBuffer);
  const privateKeyHex = bufferToHex(privateKeyBuffer);

  return [privateKeyHex, publicKeyHex];
};

// ArrayBuffer转十六进制字符串
const bufferToHex = (buffer:any) => {
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
};

// 十六进制字符串转ArrayBuffer
const hexToBuffer = (hexString: string) => {
  return new Uint8Array(hexString.match(/.{1,2}/g)!.map(byte => parseInt(byte, 16))).buffer;
};

export const performEcdhKeyExchange = async (privateKeyHex: string, peerPublicKeyHex: string) => {
  // 将十六进制字符串转换为ArrayBuffer
  const privateKeyBuffer = hexToBuffer(privateKeyHex);
  const peerPublicKeyBuffer = hexToBuffer(peerPublicKeyHex);

  // 导入私钥和对方的公钥
  const privateKey = await window.crypto.subtle.importKey(
    'pkcs8',
    privateKeyBuffer,
    {
      name: 'ECDH',
      namedCurve: 'P-256'
    },
    false,
    ['deriveKey', 'deriveBits']
  );

  const peerPublicKey = await window.crypto.subtle.importKey(
    'raw',
    peerPublicKeyBuffer,
    {
      name: 'ECDH',
      namedCurve: 'P-256'
    },
    false,
    []
  );

  // 计算共享密钥
  const sharedSecret = await window.crypto.subtle.deriveBits(
    {
      name: 'ECDH',
      public: peerPublicKey
    },
    privateKey,
    256
  );

  // 将共享密钥转换为十六进制字符串
  const sharedSecretHex = bufferToHex(sharedSecret);

  // 从共享密钥派生对称密钥
  const symmetricKey = deriveSymmetricKey(sharedSecretHex);

  return symmetricKey;
};


function deriveSymmetricKey(sharedSecret: string) {
  // 从共享密钥中派生对称密钥
  return sharedSecret.slice(0, 32)
}

class EcdhKey {
  keyIndent = ''
  clientPrivateKeyHex = ''
  serverPublicKeyHex = ''
  shareKey = ''

  constructor(keyindent: string, cpkh: string, spkh: string) {
    this.keyIndent = keyindent
    this.clientPrivateKeyHex = cpkh
    this.serverPublicKeyHex = spkh
    this.performKeyExchange();
  }
  async performKeyExchange() {
    this.shareKey = await performEcdhKeyExchange(this.clientPrivateKeyHex, this.serverPublicKeyHex);
  }
}

export default EcdhKey